import { render, staticRenderFns } from "./NavError.vue?vue&type=template&id=2ab2c393&scoped=true&"
import script from "./NavError.vue?vue&type=script&lang=js&"
export * from "./NavError.vue?vue&type=script&lang=js&"
import style0 from "./NavError.vue?vue&type=style&index=0&id=2ab2c393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2c393",
  null
  
)

component.options.__file = "NavError.vue"
export default component.exports